import React from 'react';
import styled from 'styled-components';

import { Typography } from '@opus1/harmony';
import { STAFF_IMPORT_PAGE_COPY } from '../constants/staffImport';
import type { ValidationIssue } from '../types/staffImport';

export interface StaffImportValidationBannerProps {
    issues: ValidationIssue[];
}

const Banner = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    border: 1px solid #f44336;
    border-radius: 8px;
    background: rgba(244, 67, 54, 0.08);
`;

const IssueList = styled.ul`
    margin: 0;
    padding-left: 20px;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    line-height: 20px;
    color: #212121;
`;

export const StaffImportValidationBanner: React.FC<
    StaffImportValidationBannerProps
> = ({ issues }) => {
    if (issues.length === 0) {
        return null;
    }

    return (
        <Banner role="alert">
            <Typography variant="body1" weight={600}>
                {STAFF_IMPORT_PAGE_COPY.validationBannerTitle(issues.length)}
            </Typography>
            <Typography variant="body2">
                {STAFF_IMPORT_PAGE_COPY.validationBannerSubtitle}
            </Typography>
            <IssueList>
                {issues.map((issue) => (
                    <li key={`${issue.rowNumber}-${issue.field}-${issue.code}`}>
                        Row {issue.rowNumber}: {issue.message}
                    </li>
                ))}
            </IssueList>
        </Banner>
    );
};

export default StaffImportValidationBanner;
